import axios from 'shared/utils/axios'
import { call, takeLatest, put } from 'redux-saga/effects'
import { getUserSession, getEmptyUserSession, setUserSession, UserSession } from './reducer'

function* GetUserSession() {
  try {
    const user_session_response: UserSession = yield call(axios.request, {
      url: '/user-session',
    })
    let payload = getEmptyUserSession()
    if (Object.keys(user_session_response).length) payload = user_session_response
    yield put(setUserSession(payload))
  } catch (err) {
    console.error(err)
  }
}

export default function* rootSaga() {
  yield takeLatest(getUserSession.type, GetUserSession)
}
